import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import CallSplitIcon from "@mui/icons-material/CallSplitOutlined";
import { NodeWrapper } from "./NodeWrapper";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { i18n } from "../../../translate/i18n";
import { mkHeaderStyle, HEADER_ICON_STYLE, HEADER_TEXT_STYLE, NODE_BODY_STYLE, mkHandleStyle } from "./nodeStyles";


import { Tooltip, IconButton } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1e293b',
    color: '#f8fafc',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #334155',
    padding: '12px 14px',
    borderRadius: '8px',
    fontFamily: "'Inter', 'Roboto', sans-serif",
    lineHeight: 1.5,
  },
  arrow: { color: '#1e293b' },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  pulseIcon: {
    color: '#ffffff',
    borderRadius: '50%',
    animation: '$glowPulse 1.5s infinite',
  },
  '@keyframes glowPulse': {
    '0%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.9)' },
    '70%': { boxShadow: '0 0 0 8px rgba(255, 255, 255, 0)' },
    '100%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' },
  },
}));

export default memo(({ data, isConnectable, id, selected }) => {
  const classes = useStyles();
  const storageItems = useNodeStorage();
  
  return (
    <NodeWrapper id={id} selected={selected} color="#D500F9">
      <Handle 
        type="target" 
        position="left" 
        style={mkHandleStyle("#D500F9", { left: "-12px", top: "20px", transform: "translateY(-50%)" })} 
        onConnect={params => console.log("handle onConnect", params)} 
        isConnectable={isConnectable} 
      />

      <div style={{ ...mkHeaderStyle("#D500F9"), justifyContent: "space-between" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <CallSplitIcon style={HEADER_ICON_STYLE} />
        <div style={HEADER_TEXT_STYLE}>{data.name || i18n.t("flowBuilder.editor.nodes.random.name")}</div>
      </div>
  <div style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
    <HtmlTooltip
            title={
              <React.Fragment>
                <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#38bdf8' }}>
                  💡 {i18n.t("flowBuilder.tooltips.randomizer.title")}
                </div>
                <div style={{ marginBottom: '0' }}>
                  <div dangerouslySetInnerHTML={{ __html: i18n.t("flowBuilder.tooltips.randomizer.body") }} />
                </div>
              </React.Fragment>
            }
            placement="right"
          >
            <IconButton size="small" style={{ padding: '4px', marginLeft: '2px' }} className={classes.pulseIcon}>
              <HelpOutlineIcon style={{ fontSize: '15px' }} />
            </IconButton>
          </HtmlTooltip>
  </div>
</div>

      <div style={NODE_BODY_STYLE}>
        {(data.percents && data.percents.length > 0 && !data.percents.includes(null) ? data.percents : [50, 50]).map((p, index) => {
          const handleId = String.fromCharCode(97 + index); // a, b, c, d
          return (
            <div key={handleId} style={{
              position: 'relative',
              height: '35px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              paddingRight: '12px' // Padding for text
            }}>
              <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: "13px", color: "#1a1a1a" }}>
                {`${i18n.t("flowBuilder.randomizer.pathName")} ${String.fromCharCode(65 + index)}: ${p}%`}
              </div>
              <Handle 
                type="source" 
                position="right" 
                id={handleId} 
                style={mkHandleStyle("#D500F9", { right: -24, top: "50%", transform: 'translateY(-50%)' })} 
                isConnectable={isConnectable} 
              />
            </div>
          );
        })}
      </div>
    </NodeWrapper>
  );
});
